import * as React from "react";
import {useState} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {Alert, Box, IconButton, TextField, TextFieldProps} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {merge} from "lodash";
import {InputProps as StandardInputProps} from "@mui/material/Input/Input";
import {ContentPaste, Visibility, VisibilityOff} from "@mui/icons-material";

export type FormInputTextProps = Omit<TextFieldProps, 'name'> & {
   name: string;
   label: string;
   errorMessage?: string

   /**
    * @deprecated now using formcontext
    */
   control?: any
}

export const FormInputSecret = ({name, label, error, errorMessage, ...rest}: FormInputTextProps) => {
   const {style, InputProps} = rest;
   const classes = useStyles();
   const [show, setShow] = useState<boolean>(false)

   const methods = useFormContext();
   const {getValues, control, formState: {errors}} = methods;
   const showError = !!errors[name];

   const newStyle = merge(style, {
      border: showError ? '1px solid #f00000' : '1px solid #d0d0d0',
      marginBottom: '8px'
   });

   const newProps: Partial<StandardInputProps> = merge(InputProps, {
      disableUnderline: true,
      style: {backgroundColor: 'transparent'}
   });

   newProps.endAdornment = <Box sx={{display: 'flex'}}>
      <IconButton size={"small"} onClick={() => setShow(!show)}>
         {show ? <VisibilityOff/> : <Visibility/>}
      </IconButton>
      <IconButton size={"small"} onClick={() => navigator.clipboard.writeText(getValues(name))}>
         <ContentPaste/>
      </IconButton>
   </Box>

   return (
      <div className={classes.noBorderRadius}>
         <Controller
            name={name}
            control={control}
            render={({
                        field: {onChange, value},
                        fieldState: {error}
                     }) => (
               <TextField
                  id={name}
                  size="small"
                  fullWidth
                  label={label}
                  variant="filled"
                  type={show ? 'text' : 'password'}
                  value={show ? value || undefined : '***********************************************'}
                  error={showError}
                  onChange={show ? onChange : () => {}}
                  margin={"none"}
                  InputLabelProps={{
                     shrink: true,
                  }}
                  InputProps={newProps}
                  style={newStyle}
                  {...rest}
               />
            )}/>
         {showError && <Alert variant="filled" severity="error">{errors[name]?.message}</Alert>}
      </div>
   );
};

const useStyles = makeStyles({
   noBorderRadius: {
      "& fieldset": {
         borderRadius: 0,
      },
      width: '100%'
   }
});
